// Simple per-site theme configuration using HSL values compatible with shadcn tokens
// Values are "H S% L%" without the hsl() wrapper, matching our CSS variable expectations.

export const siteThemeMap = {
  web3: {
    lightPrimary: "221 83% 53%", // blue
    darkPrimary: "221 70% 60%",
  },
  mccb: {
    lightPrimary: "142 72% 29%", // green
    darkPrimary: "142 40% 45%",
  },
  tmmw: {
    lightPrimary: "0 100% 50%", // red
    darkPrimary: "0 100% 30%", // dark red
  },
  default: {
    lightPrimary: "221 83% 53%",
    darkPrimary: "224 76% 48%",
  },
};

export function applySiteTheme(siteId, isDark) {
  try {
    const theme = siteThemeMap[siteId] || siteThemeMap.default;
    const primary = isDark ? theme.darkPrimary : theme.lightPrimary;
    const root = document.documentElement;
    root.style.setProperty("--primary", primary);
    root.style.setProperty("--ring", primary);
    // Compute bar color: use light primary in light mode, a darker variant of light primary in dark mode
    const computeDarkerFromLight = (hslString, reduceBy = 18) => {
      try {
        const [h, sPart, lPart] = hslString.split(" ");
        const s = parseFloat(sPart.replace("%", ""));
        const l = parseFloat(lPart.replace("%", ""));
        const newL = Math.max(0, Math.min(100, l - reduceBy));
        return `${h} ${s}% ${newL}%`;
      } catch (_) {
        return hslString;
      }
    };
    const chartBar = isDark ? computeDarkerFromLight(theme.lightPrimary) : theme.lightPrimary;
    root.style.setProperty("--chart-bar", chartBar);
  } catch (_) {
    // no-op
  }
}

export function getStoredTheme() {
  if (typeof window === "undefined") return "light";
  return localStorage.getItem("theme") || "light";
}

export function setStoredTheme(mode) {
  try {
    localStorage.setItem("theme", mode);
  } catch (_) {}
}

export function applyDarkClass(mode) {
  const root = document.documentElement;
  if (mode === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
}


